import datetimeProvider from "../../../../../providers/datetime.provider";
import { packages } from "../../../../constant/marketing/product.constant";

/**
 * Promo "Absoluto" — 21 a 25/09/2026.
 *
 * Tudo depende do cupom INEDITO (voucher por pacote no backend): o desconto no
 * pacote e o Cálculo Complexo pelo preço da petição só existem com o cupom
 * aplicado no checkout. Sem cupom, o pacote é vendido e entregue como sempre —
 * por isso todo texto daqui nomeia o cupom e o CTA do marketplace já abre o
 * checkout com ele (`eventVoucherCode`).
 *
 * `eventVoucherDiscount` fica de fora de propósito: o desconto varia por pacote
 * (10/15/10) e esse campo é um número único consumido pelo upsell.
 */
const VOUCHER_CODE = "INEDITO";

const VALIDITY_NOTE = (
    <span>
        Promoção válida de{" "}
        <strong style={{ background: "#4F46E5", color: "#fff", fontWeight: 800, borderRadius: 5, padding: "1px 9px", whiteSpace: "nowrap" }}>21 a 25/09</strong>
    </span>
);

const LIGHT_CARD_CHIP = { border: "#6366F1", color: "#4F46E5" };
const DARK_CARD_CHIP = { border: "#A5B4FC", color: "#C7D2FE" };

const GIFT_ITEM_STYLE = { background: "#EEF2FF", color: "#3730A3" };

const absolutoPackage = (name, discountPercentage, calculationPrice, chipStyle) => ({
    name,
    note: VALIDITY_NOTE,
    couponChip: {
        ...chipStyle,
        text: `${discountPercentage}% OFF + Cálculo Complexo R$ ${calculationPrice} · cupom ${VOUCHER_CODE}`,
    },
    giftItem: {
        ...GIFT_ITEM_STYLE,
        text: `Com o cupom ${VOUCHER_CODE}: ${discountPercentage}% OFF no pacote e todo Cálculo Complexo por R$ ${calculationPrice} (o mesmo preço da petição)`,
    },
});

const eventAbsoluto2026Config = {
    key: "absoluto2026",
    label: "Pacotes Absolutos",
    initialDate: "2026-09-21",
    finalDate: "2026-09-25",
    eventVoucherCode: VOUCHER_CODE,
    validator: function () {
        return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, "day", "[]");
    },
    priceTableNote: `Com o cupom ${VOUCHER_CODE}, o Cálculo Complexo custa o mesmo que a petição: R$ 160 no Start, R$ 140 no Premium e R$ 120 no Infinity — até 25/09.`,
    header: () => (
        <div className="flex justify-center mb-6">
            <div className="inline-flex items-center gap-2 rounded-full border border-indigo-300 bg-indigo-400/10 px-4 py-2 text-sm font-bold text-indigo-200">
                <span aria-hidden="true">✦</span>
                Pacotes Absolutos: com o cupom {VOUCHER_CODE}, Cálculo Complexo pelo preço da petição + até 15% OFF — só até 25/09
            </div>
        </div>
    ),
    additionalMessage: () => (
        <div className="text-center mt-10">
            <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4 max-w-2xl mx-auto">
                <p className="text-sm font-medium text-indigo-800">
                    ✦ Pacotes Absolutos, de <strong>21 a 25/09</strong>: aplique o cupom <strong>{VOUCHER_CODE}</strong> no checkout e leve
                    {" "}<strong>10% OFF</strong> no Start e no Infinity, <strong>15% OFF</strong> no Premium e todo
                    {" "}<strong>Cálculo Complexo pelo preço da petição</strong> (R$ 160, R$ 140 e R$ 120).
                </p>
                <p className="text-xs text-indigo-700 mt-2">
                    O desconto e o preço do Cálculo Complexo só valem com o cupom {VOUCHER_CODE} aplicado. O preço promocional do cálculo vale enquanto durar o saldo do pacote.
                </p>
            </div>
        </div>
    ),
    packages: {
        [packages.start.id]: absolutoPackage("Start Absoluto", 10, 160, LIGHT_CARD_CHIP),
        [packages.premium.id]: absolutoPackage("Premium Absoluto", 15, 140, DARK_CARD_CHIP),
        [packages.infinity.id]: absolutoPackage("Infinity Absoluto", 10, 120, LIGHT_CARD_CHIP),
    },
};

export default eventAbsoluto2026Config;
